import { render, staticRenderFns } from "./PageViewStaff.vue?vue&type=template&id=7bc8a24c"
import script from "./PageViewStaff.vue?vue&type=script&lang=js"
export * from "./PageViewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports